import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

//models
import { signUpModel } from '../../models/signup/signup.model';


@Component({
  selector: 'app-signup',
  templateUrl: './faq.component.html'
})
export class faqComponent implements OnInit {

  //variable deceleration
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  

  constructor(public http: HttpTestService, public session: sessionServices) { }

  ngOnInit() {
	  this.getSession();
 }
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
	}
}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/faq/faq.component.ts